export const CREDIT_LIST_REQUEST = "CREDIT_LIST_REQUEST";
export const CREDIT_LIST_SUCCESS = "CREDIT_LIST_SUCCESS";
export const CREDIT_LIST_FAIL = "CREDIT_LIST_FAIL";
